<template>
  <div :id="MODE_SPECIFIC_UI_ID">
    <div
      class="mode-specific-ui-inner"
      v-for="mode in MODES_ARRAY"
      v-show="mode.id === currentModeId"
      :key="mode.id"
      :id="mode.uiHtmlId"
    >
      <component
        :is="mode.uiComponent"
        :mode-id="mode.id"
      ></component>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useModes } from '@/composables/useModes';
  import { MODE_SPECIFIC_UI_ID } from '@/enums/html-ids';

  const { MODES_ARRAY, currentModeId } = useModes();
</script>

<style scoped>
  .mode-specific-ui-inner {
    text-align: left;
    padding: 0px;
    margin: 0px 0px 6px 0px;
    font-size: 14px;
    background-color: #f2f5f7;
    border: 1px solid #c0ced8;
    border-radius: 3px;
    position: relative;
  }
</style>
